export default __webpack_public_path__ + "static/media/mars45.da6106fe.gif";